import FrameComponent from "./FrameComponent";
import "./SignUp.css";
import Header from "./landingComponents/Header";

const SignUp = () => {
  return (
    <div className="loginWrapper">
      <Header disappearNavlink={true} disappearRegister={true} />

      <div className="frame-root">
        <div className="sign-up-group">
          <h1 className="sign-up3">Sign Up</h1>
          <div className="sign-up-with1">Sign Up with Forex Miner</div>
        </div>
        <FrameComponent />
      </div>
    </div>
  );
};

export default SignUp;
